import { IsNotNull } from '../../controllers/commons/helper';
const { crypter_s, crypter_c } = require("../../controllers/encrypt/encrypt");
const jwt = require("jsonwebtoken");

const loadAuth = async () => {
  let encrypt_jwt_token, decrypt_rs, user
  try {
    const token_ls = JSON.parse(localStorage.getItem("authUser"));

    if (!IsNotNull(token_ls)) {
      return [decrypt_rs, encrypt_jwt_token, user]
    }

    let tkn = token_ls.token
    if (IsNotNull(tkn)) {
      let decrypted = await crypter_s().decrypt(tkn)

      let rs_d = jwt.decode(decrypted);
      if (rs_d.exp * 1000 < Date.now()) {
        localStorage.clear();
        window.location.href = `${process.env.REACT_APP_DOMAIN}`
      } else {
        decrypt_rs = await crypter_s().decrypt(token_ls.token);
        encrypt_jwt_token = await crypter_c().encrypt(decrypt_rs);
        user = token_ls.user
      }
    } else {
      localStorage.clear();
      window.location.href = `${process.env.REACT_APP_DOMAIN}`
    }

    return [decrypt_rs, encrypt_jwt_token, user]
  } catch (error) {
    console.log(error)
  }

};

export { loadAuth }